import { render, staticRenderFns } from "./student-wise-report.vue?vue&type=template&id=0ba6930f&scoped=true&"
import script from "./student-wise-report.vue?vue&type=script&lang=js&"
export * from "./student-wise-report.vue?vue&type=script&lang=js&"
import style0 from "./student-wise-report.vue?vue&type=style&index=0&id=0ba6930f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6930f",
  null
  
)

export default component.exports